import InputField from './InputField';
import SelectField from './SelectField';
import ToggleField from './ToggleField';
import GroupField from './GroupField';
import BlockField from './BlockField';
import LocationField from './LocationField';
import FileField from './FileField';
import DerivedField from './derived/DerivedField';
import DerivedSelectField from './derived/DerivedSelectField';
import DerivedLocationField from './derived/DerivedLocationField';

export const paramTypes = {
  numeric: InputField,
  string: InputField,
  options: SelectField,
  boolean: ToggleField,
  group: GroupField,
  block: BlockField,
  location: LocationField,
  file: FileField,
};

export const derivedParamTypes = {
  numeric: DerivedField,
  string: DerivedField,
  options: DerivedSelectField,
  location: DerivedLocationField,
};
